import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=36842fdf&scoped=true&v-if=list.length%20%3E%200&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"
import style0 from "./Information.vue?vue&type=style&index=0&id=36842fdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36842fdf",
  null
  
)

export default component.exports